import { Outlet } from "react-router-dom";
import SideBar from "../components/sideBar/SideBar";
import { Box } from "@mui/material";
import Navbar from "../components/navbar/Navbar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function Layout() {
    const { i18n } = useTranslation();

    const [open, setOpen] = useState(true);
    const [lng, setLng] = useState(i18n.language);

    useEffect(() => {
        const onLanguageChanged = (lng) => {
            setLng(lng);
        };
        i18n.on('languageChanged', onLanguageChanged);

        return () => {
            i18n.off('languageChanged', onLanguageChanged);
        };
    }, [i18n]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', direction: lng === 'ar' ? 'rtl' : 'ltr' }}>
            <div className="no-print">
                <Navbar />
            </div>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: open ? (`1.5fr 10.5fr`) : ({ md: `0.5fr 11.5fr`, xs: `1.5fr 10.5fr` }),
                    flex: 1,
                    minHeight: 0,
                    '@media print': {
                        gridTemplateColumns: '1fr',
                    }
                }}
            >
                <Box
                    sx={{
                        overflowY: 'auto',
                        height: '100%',
                        '@media print': {
                            display: 'none',
                        },
                        '&::-webkit-scrollbar': {
                            width: 6,
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'transparent',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(148,163,184,0.6)',
                            borderRadius: 999,
                        },
                    }}
                >
                    <SideBar open={open} setOpen={setOpen} direction={lng === 'ar' ? 'rtl' : 'ltr'} />
                </Box>

                <Box
                    sx={{
                        height: '100%',
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        '@media print': {
                            height: 'auto',
                            overflow: 'visible',
                        },
                        '&::-webkit-scrollbar': {
                            width: 6,
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'transparent',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(148,163,184,0.6)',
                            borderRadius: 999,
                        },
                        '&:hover::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(148,163,184,0.9)',
                        },
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgba(148,163,184,0.8) transparent',
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}

export default Layout;
